export const reportsData = [
  {
    name: "Order Reports",
    action: "Download",
    type: "ODR",
  },
  {
    name: "AGM Reports",
    action: "Download",
    type: "AGM",
  },
];
